import React from 'react'

import { VisibleProps } from './Visible.types'

const Visible: React.FC<VisibleProps> = ({ visible, children }) => (visible ? children : null)

export default Visible
